export const BASE_URL = `${process.env.REACT_APP_ENDPOINT || "https://beta-api.sitrack.io"}`;
export const PROCESS_ID = `${process.env.PROCESS_ID || "2d8fd4ea-0212-40fa-836e-10c8376e5318"}`;
export const DEV_ACCOUNT_ID = `${process.env.DEV_ACCOUNT_ID || "00000000-0000-0000-0000-000000000066"}`;

// let session = localStorage.getItem("token");
export const AUTH = undefined;
// {
//   Authorization: `Bearer ${session != null ? session : ""}`
// };
